import gsap from "gsap";
const navMenuItems = document.querySelectorAll('.mobile-buttons svg');
const amsLogo = document.querySelectorAll('header .logo-container g g:first-child path'); 
const burgerIcon = document.querySelector('.mobile-menu-btn');

if(burgerIcon) {
    burgerIcon.addEventListener('click', () => {
        if(burgerIcon.classList.contains('active')) {
            burgerIcon.classList.remove('active');
            navMenuItems.forEach(item => {
                item.classList.remove('white-bg');
            });
            amsLogo.forEach(item => {
                item.style.fill = '#FFF';
            });
            document.body.style.position = 'static';
            gsap.to('.mobile-menu-wrapper', {duration: 0.3, right: '-100%'});
        } else {
            console.log(navMenuItems);
            burgerIcon.classList.add('active');
            navMenuItems.forEach(item => {
                console.log(item);
                item.classList.add('white-bg');
            });
            amsLogo.forEach(item => {
                item.style.fill = '#283343';
            });
            document.body.style.position = 'fixed';
            gsap.to('.mobile-menu-wrapper', {duration: 0.3, right: 0});
        }
    });
}

const mobileNavItem = document.querySelectorAll('.mobile-menu-wrapper .mobile-nav-menu__item.has-children');
if(mobileNavItem) {
    mobileNavItem.forEach((item) => {
        item.addEventListener('click', (e) => {
            mobileSetActiveMenu(item, 'mobile-nav-active', '.mobile-submenu-container', e);
        });
    });
}

const mobileSubNavItem = document.querySelectorAll('.mobile-submenu-container .sub-nav-container .sub-nav-container__item.has-children');
if(mobileSubNavItem) {
    mobileSubNavItem.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();
            mobileSetActiveMenu(item, 'sub-nav-active', '.sub-nav-child');
        });
    });
}

const mobileSubNavGrandChild = document.querySelectorAll('.mobile-submenu-container .sub-nav-child .sub-nav-child__item.has-children');
if(mobileSubNavGrandChild) {
    mobileSubNavGrandChild.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();
            mobileSetActiveMenu(item, 'sub-nav-grandchild-active', '.sub-nav-grandchild');
        });
    });
}

const mobileSetActiveMenu = (item, activeClass, subMenuClass, event) => {

    if(item.classList.contains(activeClass)) {
        item.classList.remove(activeClass);
        gsap.to(item.querySelector(subMenuClass), {duration: 0.3, height: 0});
    } else {
        [...item.parentElement.children].forEach((sib)=> {
            sib.classList.remove(activeClass);
            gsap.to(sib.querySelector(subMenuClass), {duration: 0.3, height: 0});
        });
        item.classList.add(activeClass);
        gsap.to(item.querySelector(subMenuClass), {duration: 0.3, height: 'auto'});
    }
}